import React from 'react';
import { parsePhoneNumber, CountryCode } from 'libphonenumber-js';

interface PhoneNumberProps {
  phone: string;
  country?: string; // 'US', 'CA', 'GB'
  className?: string;
  showIcon?: boolean;
  country_code?: string;
}

// Country code to flag emoji mapping
const countryToFlag: Record<string, string> = {
  'US': '',
  'CA': '',
  'GB': '',
};

// Country code mapping
const countryCodeMap: Record<string, CountryCode> = {
  'US': 'US',
  'CA': 'CA',
  'GB': 'GB',
};

export const PhoneNumber: React.FC<PhoneNumberProps> = ({
  phone,
  country = 'US',
  className = '',
  showIcon = true,
  country_code = '+1'
}) => {
  if (!phone) return <span className={className}>—</span>;

  try {
    // Get the country code for libphonenumber
    const countryCode = countryCodeMap[country] || 'US';
    let  phoneWithCountryCode = phone;
    if(country_code != undefined && !phone.startsWith('+')) {
      phoneWithCountryCode = country_code + phone;
    }
    // Parse and format the phone number
    const phoneNumber = parsePhoneNumber(phoneWithCountryCode, countryCode);

    if (!phoneNumber) {
      // If parsing fails, return the original phone number
      return <span className={className}>{phoneWithCountryCode}</span>;
    }

    // Format the phone number in international format
    let flag = countryToFlag[country];
    const formattedNumber = phoneNumber.formatInternational();
    if(phoneNumber.country && phoneNumber.country.toLowerCase() != country.toLowerCase())
    {
      flag = countryToFlag[phoneNumber.country];
    }

    return (
      <span className={`inline-flex items-center gap-2 ${className}`}>
        {showIcon && flag && (
          <span className="text-base" style={{ lineHeight: 1 }}>
            {flag}
          </span>
        )}
        <span>{formattedNumber}</span>
      </span>
    );
  } catch (error) {
    // If any error occurs, return the original phone number
    console.error('Error formatting phone number:', error);
    return <span className={className}>{phone}</span>;
  }
};

export default PhoneNumber;
